import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "child-categories" }
const _hoisted_2 = { class: "child-categories__list" }
const _hoisted_3 = { class: "child-categories__item" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 0,
  class: "child-categories__item"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "child-categories__item"
}
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", {
      onRootMouseenter: $setup.onRootMouseenter,
      activeMenu: $setup.activeMenu,
      isActiveId: $setup.isActiveId
    }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activeMenu, (item) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("a", {
              class: _normalizeClass(["child-categories__link", { 'child-categories__link--head': !!item.children}]),
              href: item.link
            }, _toDisplayString(item.title), 11, _hoisted_4)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (i < 5)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _createElementVNode("a", {
                      class: "child-categories__link",
                      href: child.link
                    }, _toDisplayString(child.title), 9, _hoisted_6)
                  ]))
                : _createCommentVNode("", true),
              (i === 6)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createElementVNode("a", {
                      class: "child-categories__link child-categories__link--rest",
                      href: item.link
                    }, _toDisplayString(_ctx.$t("View all")), 9, _hoisted_8)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]))
      }), 256))
    ]),
    _renderSlot(_ctx.$slots, "banner")
  ], 64))
}